export function fromQueryToObjOfParams(query: string) {
    const sanitizedQuery = query.replace('?', '');
    const queriesArray: string[] = sanitizedQuery.split('&');
    const returnObj: any = {};
    for (let index = 0; index < queriesArray.length; index++) {
        const element = queriesArray[index].split('=');
        returnObj[element[0]] = element[1];
    }
    return returnObj;
}